import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'
import { useCADQuery } from '@/services/queries/cads'

import { useAppStore } from '@/state'
import { useCADPageStore } from '@/state/cad'

export const useThreeWindowInit = () => {
  const { camera, gl } = useThree()

  const { data: cadData } = useCADQuery()
  const gltf = cadData?.gltf

  useEffect(() => {
    if (window.Cypress || window.lambdaAutomation) {
      // @ts-expect-error - extending window for Cypress testing & automation
      window.$$appStore = useAppStore

      // @ts-expect-error - extending window for Cypress testing & automation
      window.$$CADPageStore = useCADPageStore

      // @ts-expect-error - Expose the GLTF object to the window for testing and automation
      window.$$Q20 = {
        gltf,
        camera,
        domElement: gl.domElement,
      }

      if (gltf) {
        // @ts-expect-error - set gltf loaded
        window.$$GLTF_loaded = true
      }
    }
  }, [camera, gl.domElement, gltf])
}
